import Resource from './Resource';

export default class LTILaunch extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let route = `class-pages/:courseSectionGuid/LTI/:line_no/:line_no_type`;

		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data: data,
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	post() {
		return this.request('post');
	}
}
